/**
 * Created by Moment on 16/8/25.
 * Vue Resource 配置
 */

import axios from 'axios'
import qs from 'qs'
import Toast from '../framework/CYZS.Toast'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'// 服务端需要的请求头

axios.interceptors.request.use(function (config) {
  config.url = process.env.VUE_APP_PLATFORM + config.url
  return config
}, function (error) {
  return Promise.reject(error)
})

/*
* 全局的HttpRequest方法(封装VueResource)
*/

window.HttpRequest = {
  /**
   * Get方法
   * @param url
   * @param params
   * @param isNeedFailback
   * @returns {Promise}
     */
  get (url, params, isNeedFailback) {
    return new Promise((resolve, reject) => {
      axios.get(url, {params}).then((response) => {
        // response = response.json();
        if (!this.hook(response.data)) {
          if (isNeedFailback) {
            reject(response.data)
          } else {
            return false
          }
        }
        resolve(response.data)
      }).catch((response) => {
        Toast.show('XHR请求出错,请联系穿衣助手客服进行反馈')
        reject(response.data)
      })
    })
  },
  /**
   * Post方法
   * @param url
   * @param params
   * @param isNeedFailback return promise when response result > 0
   * @returns {Promise}
     */
  post (url, params, isNeedFailback) {
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params)).then((response) => {
        // response = response.json();
        if (!this.hook(response.data)) {
          if (isNeedFailback) {
            reject(response.data)
          } else {
            return false
          }
        }
        resolve(response.data)
      }).catch((response) => {
        Toast.show('XHR请求出错,请联系穿衣助手客服进行反馈')
        reject(response.data)
      })
    })
  },

  /**
   * http response 钩子:做一些状态判断
   * @param response
   * @returns {boolean}
     */
  hook (response) {
    if (response.result > 0) {
      // result == 2,当前未登陆
      if (response.result == 2) {
        if (location.host.indexOf('local.ichuanyi.com') > -1 || location.host.indexOf('apitest.ichuanyi.com') > -1) {
          // TODO Moment apitest环境Login之后服务端不支持url redirect,暂时被迫搁浅
          location.href = 'https://apitest.ichuanyi.com/admin.php?method=index.login'
        } else {
          let url = getUrl()
          url = `${url}?method=index.login&redirectURL=${location.href}`
          if (location.host.indexOf('apitest') > -1) {
            location.href = 'https://cas.yourdream.cc/cas2/login?service=' + url
          } else {
            location.href = 'https://ichuanyi.com/cas2/login?service=' + url
          }
        }
        return false
      } else {
        if (response.msg && response.msg.error) {
          Toast.show(response.msg.error)
        } else {
          Toast.show('接口参数错误，请联系穿衣助手客服进行反馈')
        }
        return false
      }
    }
    return true
  }
}

/**
 * 获得当前url,并转换为后台地址
 * 登录页面地址为:
 * https://ichuanyi.com/cas/login?service=https://[outertest.]ichuanyi.com/admin.php?method=index.login&redirectURL=https://[outertest.]ichuanyi.com/adminv/#!xxxx
 * https://ichuanyi.com/cas/login?service=https://outertest.ichuanyi.com/admin.php?method=index.login&redirectURL=https://outertest.ichuanyi.com/adminv/#!/Dashboard
 */
function getUrl () {
  var origin = location.origin
  return `${origin}/admin.php`
}

/**
 * 其他类型的请求注册
 */
(function () {
  let requestType = ['delete', 'head', 'options', 'put', 'patch']
  for (let i = 0, len = requestType.length; i < len; i++) {
    let typeItem = requestType[i]
    HttpRequest[typeItem] = (url, params, isNeedFailback) => {
      return new Promise((resolve, reject) => {
        axios[typeItem](url, qs.stringify(params)).then((response) => {
          // response = response.json();
          if (!HttpRequest.hook(response.data)) {
            if (isNeedFailback) {
              reject(response.data)
            } else {
              return false
            }
          }
          resolve(response.data)
        }).catch((response) => {
          Toast.show('XHR请求出错,请联系穿衣助手客服进行反馈')
          reject(response.data)
        })
      })
    }
  }
})()
